export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Hydroponics Grower Ready after purchasing?',
    a: ['You receive immediate digital access to the complete material after your purchase is completed.'],
  },
  {
    q: 'Do I need previous hydroponics experience?',
    a: [
      'No.',
      'The system begins with setup and fundamentals and progresses into crops, optimization and troubleshooting.',
    ],
  },
  {
    q: 'Do I need a large garden?',
    a: [
      'No.',
      'Hydroponics can be adapted to different spaces, including indoor areas, balconies, patios, garages and other suitable home growing spaces.',
    ],
  },
  {
    q: 'Is this traditional gardening?',
    a: ['No.', 'Hydroponics Grower Ready focuses specifically on soilless hydroponic growing systems.'],
  },
  {
    q: 'Is the system really visual?',
    a: [
      'Yes.',
      'The main system is built around diagrams, crop visuals, system maps, comparisons, sequences, quick-reference tools, troubleshooting charts and visual growing guides.',
    ],
  },
  {
    q: 'Does the package include videos?',
    a: ['No.', 'The material is delivered as visual digital guides. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes.', 'The complete system is in English.'],
  },
  {
    q: 'Can I edit the material?',
    a: ['No.', 'The material is delivered for use in its finished digital format.'],
  },
  {
    q: 'Is this only for beginners?',
    a: [
      'No.',
      'Beginners can follow the complete process from the beginning, while existing growers can use the crop, optimization and troubleshooting resources as quick references.',
    ],
  },
  {
    q: 'What can I grow with it?',
    a: [
      'The system covers popular hydroponic crops including leafy greens, herbs and fruiting crops such as lettuce, basil, kale, tomatoes, peppers, cucumbers, strawberries and more.',
    ],
  },
]
